import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { apiFetch } from '../../utils/api';
import { toast } from 'react-toastify';
import { FiMail } from 'react-icons/fi';

const EmailVerificationBanner = () => {
    const { user } = useAuth();
    const [isResending, setIsResending] = useState(false);

    // Ne pas afficher si l'utilisateur n'est pas connecté ou si l'email est déjà vérifié
    if (!user || user.isEmailVerified) {
        return null;
    }

    const handleResendVerification = async () => {
        setIsResending(true);
        try {
            await apiFetch(`${process.env.REACT_APP_API_URL}/users/resend-verification`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: user.email })
            });
            toast.success('Email de vérification renvoyé ! Vérifiez votre boîte de réception.');
        } catch (error) {
            toast.error(error.response?.data?.message || 'Erreur lors de l\'envoi de l\'email');
        } finally {
            setIsResending(false);
        }
    };

    return (
        <div className="bg-white dark:bg-gray-800">
            <div className="max-w-7xl mx-auto py-3 px-4 sm:px-6 lg:px-8">
                <div className="flex flex-wrap items-center justify-between">
                    <div className="flex items-center flex-1">
                        <span className="flex p-2 rounded-lg bg-yellow-100 dark:bg-yellow-900/40">
                            <svg className="h-5 w-5 text-yellow-600 dark:text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                        </span>
                        <p className="ml-3 text-sm font-medium text-yellow-800 dark:text-yellow-200">
                            Vérifiez votre boîte de réception (et les spams) pour trouver l'email de vérification.
                        </p>
                    </div>
                    <div className="mt-2 sm:mt-0 flex-shrink-0">
                        <button
                            onClick={handleResendVerification}
                            disabled={isResending}
                            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-yellow-800 dark:text-yellow-200 bg-yellow-100 dark:bg-yellow-900/40 hover:bg-yellow-200 dark:hover:bg-yellow-900/60 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {isResending ? (
                                <>
                                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Envoi...
                                </>
                            ) : (
                                <>
                                    <FiMail /> 
                                    <p className='ml-2'>Renvoyer l'email</p>
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmailVerificationBanner;
